import * as React from 'react'

import AutoplaySwitcher from './autoplaySwitcher'
import MuteSwitcher from './muteSwitcher'

import * as styles from './videoControlls.module.css'

export interface IProps {
  muted: boolean
  autoplay: boolean
  enableAutoplay: (muted: boolean) => any
  onMute: () => any
  onUnmute: () => any
}

const VideoControlls = ({
  muted,
  autoplay,
  enableAutoplay,
  onMute,
  onUnmute
}: IProps) => {
  return (
    <div className={styles.root}>
      {!autoplay && <AutoplaySwitcher onClick={() => enableAutoplay(muted)} />}
      <MuteSwitcher muted={muted} onMute={onMute} onUnmute={onUnmute} />
    </div>
  )
}

export default VideoControlls
